module.exports = __webpack_public_path__ + "img/team.e89cb54a.jpg";